import toastr from 'toastr';
import 'toastr/toastr.scss';

const Setup = () => {

    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-full-width",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }
}

const Success = (message) => {
    toastr.success(message);
}

const Info = (message) => {
    toastr.info(message);
}

const Warning = (message) => {
    toastr.warning(message);
}

const Error = (message) => {
    toastr.error(message);
}

const Messages = [];

Setup();

const ToastMessage = { Setup, Success, Info, Warning, Error, Messages };

Window.ToastMessage = ToastMessage;
